<div class="fg-form d-flex">
    <div class="container d-flex">
        <div class="row align-items-center justify-content-center flex-grow-1">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card overflow-hidden forgot-password-pages">
                    <div class="bg-soft bg-primary">
                        <div class="row">
                            <div class="col-7">
                                <div class="text-white-50 p-4">
                                    <!-- <h5 class="text-white-50"> Confirm Password</h5> -->
                                    <span>Your password has been expired!</span>
                                    <p>Set your password with Xpresion Next.</p>
                                </div>
                            </div>
                            <div class="col-5 align-self-end">
                                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0 fg-card">

                        <form class="needs-validation" [formGroup]="resetPasswordForm" (ngSubmit)="onFormSubmit()">
                            <div class="mt-4 mb-4 form-group">
                                <input type="{{ hidePassword ? 'password' : 'text' }}" class="form-control"
                                    id="password" placeholder="" formControlName="txtPassword"
                                    [ngClass]="{ 'is-invalid': isFormSubmitted && resetPasswordForm.get('txtPassword').errors }" />
                                <label for="password" class="control-label text-white-50 form-label">Password</label>
                                <button
                                    class="btn bg-transparent text-white border position-absolute top-0 border-opacity-50 form-icon"
                                    type="button" id="password" (click)="hidePassword=!hidePassword">
                                    <i [class]="hidePassword ? 'mdi mdi-eye-outline' : 'mdi mdi-eye-off-outline' "></i>
                                </button>

                                <div *ngIf="isFormSubmitted && resetPasswordForm.get('txtPassword').errors"
                                    class="invalid-feedback">
                                    <div *ngIf="resetPasswordForm.get('txtPassword').errors.required">
                                        Password is required
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4 mb-4 form-group">
                                <input type="{{ hideconfirmpassword ? 'password' : 'text' }}" class="form-control"
                                    id="password" placeholder="" formControlName="txtConfirmPassword"
                                    [ngClass]="{ 'is-invalid': isFormSubmitted && resetPasswordForm.get('txtConfirmPassword').errors }" />
                                <label for="confirmpassword" class="control-label text-white-50 form-label">Confirm
                                    Password</label>
                                <button
                                    class="btn bg-transparent text-white border position-absolute top-0 border-opacity-50 form-icon"
                                    type="button" id="password" (click)="hideconfirmpassword=!hideconfirmpassword">
                                    <i
                                        [class]="hideconfirmpassword ? 'mdi mdi-eye-outline' : 'mdi mdi-eye-off-outline' "></i>
                                </button>

                                <div *ngIf="isFormSubmitted && resetPasswordForm.get('txtConfirmPassword').errors"
                                    class="invalid-feedback">
                                    <div *ngIf="resetPasswordForm.get('txtConfirmPassword').errors.required">
                                        Confirm Password is required
                                    </div>
                                </div>

                                <span
                                    *ngIf="resetPasswordForm.get('txtConfirmPassword').value && resetPasswordForm.errors?.mismatch"
                                    class="custom-error-message">
                                    Passwords doesn't match.
                                </span>
                            </div>
                            <div class="text-end">
                                <button class="btn login-btn btn-block" type="submit">Confirm</button>
                            </div>
                        </form>

                    </div>
                </div>
                <div class="mt-5 text-center">
                    <p class="mb-0">
                        © {{ year }} Powered by
                        <img width="100" src="assets/images/busisoft_logo.png"  />
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>